/* =====================================================================
   RYNOR – shared language + currency helpers (v38)

   window.RynorStrings     words for scripts, written by layout/theme.liquid from the
                           language files (locales/*.json), so scripts never hard-code English
   window.RynorI18nConfig  store currency / shopper currency / language (layout/theme.liquid)

   RynorI18n.str(key, fallback)      a word from RynorStrings
   RynorI18n.formatThreshold(cents)  a store-currency amount (USD cents) shown in the shopper's
                                     currency, rounded up to a whole number ("138 €")
   RynorI18n.formatShopWhole(cents)  a store-currency amount in the store's own format ("$150")
   RynorI18n.formatLocalCents(cents) an amount already in the shopper's currency
   RynorI18n.freeShipping(el)        free-shipping bar maths for carts in another currency
                                     (snippets/cart-shipping-countdown.liquid)

   Every element with data-rynor-shop-cents (snippets/rynor-free-shipping-amount.liquid) is
   converted on load when the shopper isn't paying in the store currency.
   ===================================================================== */
(function () {
  'use strict';

  if (window.RynorI18n) return;

  var cfg = window.RynorI18nConfig || {};

  function shopCurrency() {
    return cfg.shopCurrency || 'USD';
  }

  function activeCurrency() {
    var s = window.Shopify && window.Shopify.currency;
    return (s && s.active) || cfg.currency || shopCurrency();
  }

  function rate() {
    var s = window.Shopify && window.Shopify.currency;
    var r = parseFloat(s && s.rate);
    return r > 0 ? r : 1;
  }

  function lang() {
    return document.documentElement.getAttribute('lang') || cfg.locale || 'en';
  }

  function converts() {
    return activeCurrency() !== shopCurrency();
  }

  function format(amount, currency, whole) {
    var opts = { style: 'currency', currency: currency };
    if (whole) {
      opts.minimumFractionDigits = 0;
      opts.maximumFractionDigits = 0;
    }
    try {
      return new Intl.NumberFormat(lang(), opts).format(amount);
    } catch (e) {
      return (whole ? String(Math.round(amount)) : Number(amount).toFixed(2)) + ' ' + currency;
    }
  }

  function toLocalCents(shopCents) {
    return Math.round((Number(shopCents) || 0) * rate());
  }

  function formatShopWhole(shopCents) {
    var units = Math.round((Number(shopCents) || 0) / 100);
    var fmt = cfg.shopMoneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, String(units));
  }

  function formatThreshold(shopCents) {
    if (!converts()) return formatShopWhole(shopCents);
    return format(Math.ceil(toLocalCents(shopCents) / 100), activeCurrency(), true);
  }

  function formatLocalCents(cents) {
    return format((Number(cents) || 0) / 100, activeCurrency(), false);
  }

  function str(key, fallback) {
    var s = window.RynorStrings || {};
    return s[key] != null && s[key] !== '' ? s[key] : fallback;
  }

  function refresh(root) {
    if (!converts()) return;
    var els = (root || document).querySelectorAll('[data-rynor-shop-cents]');
    for (var i = 0; i < els.length; i++) {
      var next = formatThreshold(els[i].getAttribute('data-rynor-shop-cents'));
      if (els[i].textContent !== next) els[i].textContent = next;
    }
  }

  /* Free-shipping bar for a cart in another currency: Liquid can't convert the store-currency
     threshold, so it hands over the numbers + both sentences and the maths happens here. */
  function freeShipping(el) {
    if (!el) return null;
    var thresholdShop = parseInt(el.getAttribute('data-threshold-shop-cents'), 10) || 0;
    var total = parseInt(el.getAttribute('data-total-cents'), 10) || 0;
    var threshold = Math.ceil(toLocalCents(thresholdShop) / 100) * 100;
    if (threshold <= 0) threshold = 1;
    var remaining = threshold - total;
    var progress = Math.max(0, Math.min(100, (total * 100) / threshold));
    var tpl = remaining > 0 ? el.getAttribute('data-tpl-remaining') : el.getAttribute('data-tpl-qualified');
    return {
      html: String(tpl || '').replace('[[amount]]', formatLocalCents(remaining)),
      progress: progress
    };
  }

  window.RynorI18n = {
    str: str,
    converts: converts,
    formatThreshold: formatThreshold,
    formatShopWhole: formatShopWhole,
    formatLocalCents: formatLocalCents,
    toLocalCents: toLocalCents,
    refresh: refresh,
    freeShipping: freeShipping
  };

  function boot() {
    refresh(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
